import { __assign } from "tslib";
import { useEffect, useState, useRef } from 'react';
import { getAxisRanges } from './utils';
var useScatterPlot = function (data, graphHeight) {
    // states
    var _a = useState({ x: 0, y: 0, yPlot: 0, xPlot: 0 }), pos = _a[0], setPos = _a[1];
    var _b = useState(false), showVerticalLine = _b[0], setShowVerticalLine = _b[1];
    var _c = useState(0), graphWidth = _c[0], setGraphWidth = _c[1];
    // refs
    var parentNode = useRef(null);
    var yPointsRef = useRef(null);
    var axisValues = getAxisRanges(data);
    var gutterSpacing = 30;
    var getGraphParentWidth = function (elem) { var _a; return (((_a = elem === null || elem === void 0 ? void 0 : elem.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) - gutterSpacing; };
    useEffect(function () {
        setGraphWidth(getGraphParentWidth(parentNode));
    }, []);
    useEffect(function () {
        window.onresize = function () { return setGraphWidth(getGraphParentWidth(parentNode)); };
    }, [parentNode]);
    // consts
    var textHeight = 16;
    var graphHeightDiff = axisValues.yMax - axisValues.yMin;
    var graphWidthDiff = axisValues.xMax - axisValues.xMin;
    var yPoints = Array.from({ length: graphHeightDiff / axisValues.yInterval + 1 }, function (_, index) { return Math.round(index * axisValues.yInterval * 1000) / 1000 + axisValues.yMin; });
    var xPoints = Array.from({ length: graphWidthDiff / axisValues.xInterval + 1 }, function (_, index) { return Math.round(index * axisValues.xInterval * 1000) / 1000 + axisValues.xMin; });
    var yRangeDiff = yPoints[yPoints.length - 1] - yPoints[0];
    var xRangeDiff = xPoints[xPoints.length - 1] - xPoints[0];
    var yRatio = graphHeight / yRangeDiff;
    var xRatio = graphWidth / xRangeDiff;
    var getGraphCoordinate = function (point, ratio) { return point * ratio; };
    var formattedGraphPoints = data.map(function (point) { return (__assign(__assign({}, point), { yPlot: graphHeight - getGraphCoordinate(point.y, yRatio) + getGraphCoordinate(axisValues.yMin, yRatio), xPlot: getGraphCoordinate(point.x, xRatio) - getGraphCoordinate(axisValues.xMin, xRatio) })); });
    return {
        pos: pos,
        setPos: setPos,
        showVerticalLine: showVerticalLine,
        setShowVerticalLine: setShowVerticalLine,
        yPointsRef: yPointsRef,
        textHeight: textHeight,
        formattedGraphPoints: formattedGraphPoints,
        getGraphCoordinate: getGraphCoordinate,
        graphWidth: graphWidth,
        axisValues: axisValues,
        yPoints: yPoints,
        xPoints: xPoints,
        yRatio: yRatio,
        parentNode: parentNode
    };
};
export default useScatterPlot;
